<svg
  width="20"
  height="20"
  viewBox="0 0 20 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10 17C14.4183 17 18 13.4183 18 9C18 4.58172 14.4183 1 10 1C5.58172 1 2 4.58172 2 9C2 13.4183 5.58172 17 10 17ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V9C9 9.26522 9.10536 9.51957 9.29289 9.70711L12.1213 12.5355C12.5118 12.9261 13.145 12.9261 13.5355 12.5355C13.9261 12.145 13.9261 11.5118 13.5355 11.1213L11 8.58579V5Z"
  />
</svg>